import React, { useContext, useEffect, createContext } from 'react';

// project-imports
import { showToast } from '../components/sweet-alert/Sweetalert';
import { delBlogComment, getBlogComments, getBlogCommentsByBlogId, getBlogsV2, getUserReactionsByParentId, postBlogComment, postUserReactions, putBlogComment, putBlogCommentlike, putBlogLike } from './salesforce_api_context';
import { ADD_BLOG_COMMENTS_BEGIN, ADD_BLOG_COMMENTS_FAILURE, ADD_BLOG_COMMENTS_SUCCESS, DELETE_BLOG_COMMENTS_BEGIN, DELETE_BLOG_COMMENTS_FAILURE, DELETE_BLOG_COMMENTS_SUCCESS, GET_BLOG_BEGIN, GET_BLOG_COMMENTS_BEGIN, GET_BLOG_COMMENTS_FAILURE, GET_BLOG_COMMENTS_SUCCESS, GET_BLOG_FAILURE, GET_BLOG_SUCCESS, GET_BLOG_USER_REACTION_BEIGN, GET_BLOG_USER_REACTION_FAILURE, GET_BLOG_USER_REACTION_SUCCESS, GLOBAL_SEARCH_BLOG_SUCCESS, PUT_BLOG_LIKES_BEGIN, PUT_BLOG_LIKES_FAILURE, PUT_BLOG_LIKES_SUCCESS, SET_BLOG_USER_REACTION_BEGIN, SET_BLOG_USER_REACTION_FAILURE, SET_BLOG_USER_REACTION_SUCCESS, UPDATE_BLOG_COMMENTS_BEGIN, UPDATE_BLOG_COMMENTS_FAILURE, UPDATE_BLOG_COMMENTS_SUCCESS } from '../constants/actions';
import blogdata from '../data/blog/PostData.json'
import blogComments from '../data/blog/blogComments.json'

// third-party
import { useDispatch, useSelector } from "react-redux";

// Create context
export const BlogContext = createContext();

export const BlogProvider = (props) => {

    // Reading store date
    const state = useSelector(state => state.blog)

    // Reading dispatch from Store
    const dispatch = useDispatch();

    // Constant functions

    // Function to get all blogs
    const fetchBlogs = async () => {
        // Configuring filters for the API
        let filters = [];

        try {

            // Dispatching the action to begin  the api calling process
            dispatch({ type: GET_BLOG_BEGIN, payload: true });

            // Calling API to get blogs 
            let response = await getBlogsV2(filters);
            // let response = blogdata;

            // Dispatching the actions on success
            dispatch({ type: GET_BLOG_SUCCESS, payload: response });

            // Showing the toast message on getting blogs successfully
            // showToast("success", "Getting blogs successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.log("46 : blog_context : Error while fetching blogs::", error && JSON.stringify(error));

            // Dispatching the actions on error
            dispatch({ type: GET_BLOG_FAILURE, payload: error && error.message });

            // Showing the toast message on getting blogs unsuccessfully 
            showToast("error", (error && error.message) ? "We are unable to get the blogs!" : "An error occurred", true, "bottom-right", false, true, 5000);

        }
    }

    // Function to get comment of blog (requires token for authentication)
    const fetchBlogComments = async (blogId) => {

        try {

            // Dispatching the action to begin  the api calling process
            dispatch({ type: GET_BLOG_COMMENTS_BEGIN, payload: true });

            // Calling API to get blog comment list 
            let response = await getBlogComments(blogId);

            // Dispatching the actions on success
            dispatch({ type: GET_BLOG_COMMENTS_SUCCESS, payload: response });

            // Showing the toast message on getting blog comments successfully
            // showToast("success", "Getting blog comments successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.log("74 : blog_context : Error while fetching blog comments::", error && JSON.stringify(error));

            // Dispatching the actions on error 
            dispatch({ type: GET_BLOG_COMMENTS_FAILURE, payload: error.message });

            // Showing the toast message on getting blog comments unsuccessfully
            showToast("error", (error && error.message) ? "We are unable to get the latest comments!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    };

    // Function to get comment of blog by blogId (requires token for authentication)
    const getFilteredBlogComment = async (blogId) => {

        try {

            // Dispatching the action to begin the api calling process
            dispatch({ type: GET_BLOG_COMMENTS_BEGIN, payload: true });

            // Calling API to get blog comment list 
            let blogsData = await getBlogCommentsByBlogId(blogId);

            // Dispatching the actions on success
            dispatch({ type: GET_BLOG_COMMENTS_SUCCESS, payload: blogsData })

            // Showing the toast message on getting blog comments successfully by blogId
            // showToast("success", "Getting blog comments successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.error('101 : blog_context : Error while getting comments of this blog::', error && JSON.stringify(error));

            // Dispatching the actions on error
            dispatch({ type: GET_BLOG_COMMENTS_FAILURE, payload: error && error.message });

            // Showing the toast message on getting blog comments by blogId unsuccessfully
            showToast("error", (error && error.message) ? "We are unable to get the comments of this blog!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    };

    // Function to update likes to blog (requires token for authentication)
    const updateBlogLikes = async (blogId, payload) => {

        try {

            // Dispatching the action to begin the api calling process
            dispatch({ type: PUT_BLOG_LIKES_BEGIN, payload: true });
            // Calling API to put blog like 
            let blogsData = await putBlogLike(blogId, payload);
            // let blogsData = [];

            // Dispatching the actions on success
            dispatch({ type: PUT_BLOG_LIKES_SUCCESS, payload: blogsData })

            // Showing the toast message on update blog likes successfully
            // showToast("success", "Blog like successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.error('128 : blog_context : Error while adding like to the blog::', error && JSON.stringify(error));

            // Dispatching the actions on error
            dispatch({ type: PUT_BLOG_LIKES_FAILURE, payload: error && error.message });

            // Showing the toast message on update blog likes unsuccessfully
            showToast("error", (error && error.message) ? "We are unable to put like to this blog!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    };

    // Function to add comment to blog (requires token for authentication)
    const insertBlogComment = async (payload) => {
        try {

            // Dispatching the action to begin  the api calling process
            dispatch({ type: ADD_BLOG_COMMENTS_BEGIN, payload: true });

            // Calling API to post blog comment
            let blogsData = await postBlogComment(payload);
            // let blogsData = [];

            // Dispatching the actions on success
            dispatch({ type: ADD_BLOG_COMMENTS_SUCCESS, payload: blogsData })

            // Showing the toast message on adding comment successfully
            // showToast("success", "Comment added successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.error('155 : blog_context : Error while adding comment to the Blog::', error && JSON.stringify(error));

            // Dispatching the actions on error
            dispatch({ type: ADD_BLOG_COMMENTS_FAILURE, payload: error && error.message });

            // Showing the toast message on adding blog comment unsuccessfully
            showToast("error", (error && error.message) ? "We are unable to post comment to this blog!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    };

    // Function to update comment to blog (requires token for authentication)
    const updateBlogComment = async (commentId, payload, userId) => {
        try {

            // Dispatching the action to begin  the api calling process
            dispatch({ type: UPDATE_BLOG_COMMENTS_BEGIN, payload: true });

            // Calling API to put blog comment 
            let blogData = await putBlogComment(commentId, payload, userId);
            // let blogData = [];

            // Dispatching the actions on success
            dispatch({ type: UPDATE_BLOG_COMMENTS_SUCCESS, payload: blogData })

            // Showing the toast message on update comment successfully
            // showToast("success", "Comment updated successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.error('182 : blog_context : Error while updating comment to the blog::', error && JSON.stringify(error));

            // Dispatching the actions on error
            dispatch({ type: UPDATE_BLOG_COMMENTS_FAILURE, payload: error && error.message });

            // Showing the toast message on updating blog comment unsuccessfully
            showToast("error", (error && error.message) ? "We are unable to update this blog comment!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    };

    // Function to add like comment to post (requires token for authentication)
    const likeBlogComment = async (commentId, payload) => {
        try {

            // Dispatching the action to begin  the api calling process
            dispatch({ type: UPDATE_BLOG_COMMENTS_BEGIN, payload: true });

            // Calling API to put blog comment like
            let blogData = await putBlogCommentlike(commentId, payload);
            // let blogData = [];

            // Dispatching the actions on success
            dispatch({ type: UPDATE_BLOG_COMMENTS_SUCCESS, payload: blogData })

            // Showing the toast message on blog comment like successfully
            // showToast("success", "Blog comment like successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.error('209 : blog_context : Error while liking comment to the blog::', error && JSON.stringify(error));

            // Dispatching the actions on error
            dispatch({ type: UPDATE_BLOG_COMMENTS_FAILURE, payload: error && error.message });

            // Showing the toast message on updating blog comment like unsuccessfully
            showToast("error", (error && error.message) ? "We are unable to put like to this blog comment!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    };

    // Function to delete blog comment (requires token for authentication)
    const deleteBlogComment = async (commentId) => {
        try {

            // Dispatching the action to begin  the api calling process
            dispatch({ type: DELETE_BLOG_COMMENTS_BEGIN, payload: true });

            // Calling API to del blog comment
            let blogData = await delBlogComment(commentId);
            // let blogData = [];

            // Dispatching the actions on success
            dispatch({ type: DELETE_BLOG_COMMENTS_SUCCESS, payload: { blogData, id: commentId } })

            // Showing the toast message on delete comment successfuly
            showToast("success", "Comment deleted successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.error('236 : blog_context : Error while deleting comment to the blog::', error && JSON.stringify(error));

            // Dispatching the actions on error 
            dispatch({ type: DELETE_BLOG_COMMENTS_FAILURE, payload: error && error.message });

            // Showing the toast message on delete comment unsuccessfully
            showToast("error", (error && error.message) ? "We are unable to delete this blog comment!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    };

    // Function to get blog user reaction 
    const getBlogUserReaction = async (parentId) => {

        // Dispatching the action to begin  the api calling process
        dispatch({ type: GET_BLOG_USER_REACTION_BEIGN, payload: true });
        try {

            // Calling API to get userReactions 
            let response = await getUserReactionsByParentId(parentId);
            // let response = [];

            // Dispatching the actions on success
            dispatch({ type: GET_BLOG_USER_REACTION_SUCCESS, payload: { blogId: parentId, userBlogReactions: response || [] } });

            // Showing the toast message on getting blog reaction successfully
            // showToast("success", "Getting Blog reaction successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.log("263 : blog_context : Error while getting blog user reaction::", error && JSON.stringify(error));

            // Dispatching the actions on error
            dispatch({ type: GET_BLOG_USER_REACTION_FAILURE, payload: error.message });

            // Showing the toast message on getting blog reaction unsuccessfully
            showToast("error", (error && error.message) ? "We are unable to get the latest user reaction!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    }

    // Function to set blog user reaction
    const handlePostBlogUserReaction = async (payload, id) => {

        // Dispatching the action to begin  the api calling process
        dispatch({ type: SET_BLOG_USER_REACTION_BEGIN, payload: true });
        try {

            // Calling API to post userReactions 
            let response = await postUserReactions(payload);
            // let response = [];

            // Dispatching the actions on success
            dispatch({ type: SET_BLOG_USER_REACTION_SUCCESS, payload: response });
            getBlogUserReaction(id)

            // Showing the toast message on reaction submitted successfully
            // showToast("success", "Reaction is submitted Successfully", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.log("291 : blog_context : Error while adding blog user reation::", error && JSON.stringify(error));

            // Dispatching the actions on error
            dispatch({ type: SET_BLOG_USER_REACTION_FAILURE, payload: error && error.message });

            // Showing the toast message on unsuccessfully reaction submission
            showToast("error", (error && error.message) ? "We are unable to submit your reaction at this moment. Please try again later!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    }

    // Fucntion to set filter blogs
    const setFilteredBlogs = (searchTerm) => {

        // Dispatching the actions on success 
        dispatch({ type: GLOBAL_SEARCH_BLOG_SUCCESS, payload: searchTerm });
    }

    useEffect(() => {
        fetchBlogs();
    }, []);

    return (
        <BlogContext.Provider value={{ ...state, fetchBlogs, updateBlogLikes, getFilteredBlogComment, insertBlogComment, updateBlogComment, likeBlogComment, fetchBlogComments, deleteBlogComment, getBlogUserReaction, handlePostBlogUserReaction, setFilteredBlogs }}>
            {props.children}
        </BlogContext.Provider>
    )
}
export const useBlogContext = () => {
    return useContext(BlogContext)
}
